import type { SelectOption } from '@shinetools/lumen-react'

// Lumen's Select has no clear control, so a saved default is removed by picking this option.
// It is only offered once there is something to remove, so an empty field still shows its placeholder.
export const withNoDefaultOption = (options: SelectOption[], value: string, label: string): SelectOption[] =>
  value ? [{ label, value: '' }, ...options] : options
